var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9564_107631",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9564_107631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99709 5.82814C8.76701 5.82814 8.57147 5.74764 8.41046 5.58662C8.24945 5.42561 8.16895 5.23007 8.16895 5C8.16895 4.76993 8.24945 4.57438 8.41046 4.41337C8.57147 4.25236 8.76701 4.17186 8.99709 4.17186H13.1689C13.399 4.17186 13.5946 4.25236 13.7556 4.41337C13.9166 4.57438 13.9971 4.76993 13.9971 5C13.9971 5.23007 13.9166 5.42561 13.7556 5.58662C13.5946 5.74764 13.399 5.82814 13.1689 5.82814H8.99709ZM8.99709 10.8281C8.76701 10.8281 8.57147 10.7476 8.41046 10.5866C8.24945 10.4256 8.16895 10.2301 8.16895 10C8.16895 9.76993 8.24945 9.57438 8.41046 9.41337C8.57147 9.25236 8.76701 9.17186 8.99709 9.17186H13.1689C13.399 9.17186 13.5946 9.25236 13.7556 9.41337C13.9166 9.57438 13.9971 9.76993 13.9971 10C13.9971 10.2301 13.9166 10.4256 13.7556 10.5866C13.5946 10.7476 13.399 10.8281 13.1689 10.8281H8.99709ZM2.92505 6.56998L1.59013 5.23506C1.43434 5.07926 1.35645 4.88632 1.35645 4.65625C1.35645 4.42618 1.43434 4.23324 1.59013 4.07744C1.74593 3.92163 1.93887 3.84373 2.16895 3.84373C2.39902 3.84373 2.59196 3.92163 2.74776 4.07744L3.49707 4.82675L5.56568 2.74931C5.72601 2.58309 5.92042 2.50259 6.14891 2.5078C6.3774 2.513 6.57181 2.59872 6.73213 2.76494C6.88794 2.92527 6.96584 3.11821 6.96584 3.34375C6.96584 3.56929 6.88794 3.76223 6.73213 3.92256L4.09151 6.56998C3.93119 6.73031 3.73678 6.81047 3.50829 6.81047C3.2798 6.81047 3.08539 6.73031 2.92505 6.56998ZM2.92505 11.57L1.59013 10.2351C1.43434 10.0793 1.35645 9.88632 1.35645 9.65625C1.35645 9.42618 1.43434 9.23324 1.59013 9.07744C1.74593 8.92164 1.93887 8.84373 2.16895 8.84373C2.39902 8.84373 2.59196 8.92164 2.74776 9.07744L3.49707 9.82675L5.56568 7.74931C5.72601 7.58309 5.92042 7.50259 6.14891 7.5078C6.3774 7.513 6.57181 7.59872 6.73213 7.76494C6.88794 7.92527 6.96584 8.11821 6.96584 8.34375C6.96584 8.56929 6.88794 8.76223 6.73213 8.92256L4.09151 11.57C3.93119 11.7303 3.73678 11.8105 3.50829 11.8105C3.2798 11.8105 3.08539 11.7303 2.92505 11.57Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/Checklist.1dd17f11afc945c31e651881a5172c94.svg";
export { ForwardRef as ReactComponent };